module.exports = __webpack_public_path__ + "img/developer_upload.2386e98a.svg";